/**
 * Stable identity for this browser tab, sent to the backend on every API
 * request (`X-Nuclearn-Tab`) and on the notification stream (`?tab=`) so it
 * can tell tabs apart: reconnects from the same tab share an entry in the
 * per-user SSE cap, and work a request starts alerts in the tab that asked.
 *
 * MUST live in module memory only — persisting to localStorage /
 * sessionStorage / cookie would collapse multi-tab semantics and silently
 * defeat the cap.
 *
 * `crypto.getRandomValues` (rather than `crypto.randomUUID`) because the
 * latter requires a secure context, and on-prem deployments often run plain
 * HTTP. The backend treats it as an opaque alphanumeric token.
 */
export const TAB_ID_HEADER = "X-Nuclearn-Tab";

const _tabIdBytes = new Uint8Array(16);
crypto.getRandomValues(_tabIdBytes);
export const TAB_ID = Array.from(_tabIdBytes, (b) =>
  b.toString(16).padStart(2, "0"),
).join("");
